import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2f35b95a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "legend" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "legend-item" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "legend-color",
    style: {"background-color":"#ffa500"}
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "legend-text" }, "PB(LF)")
], -1))
const _hoisted_4 = { class: "legend-item" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "legend-color",
  style: {"background-color":"#a033ff"}
}, null, -1))
const _hoisted_6 = { class: "legend-text" }
const _hoisted_7 = { class: "legend-item" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "legend-color",
  style: {"background-color":"#4191ff"}
}, null, -1))
const _hoisted_9 = { class: "legend-text" }
const _hoisted_10 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_radio_button = _resolveComponent("a-radio-button")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_Charts = _resolveComponent("Charts")!
  const _component_Nodata = _resolveComponent("Nodata")!
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createBlock(_component_a_spin, {
    tip: "加载中...",
    spinning: _ctx.spinning
  }, {
    default: _withCtx(() => [
      (_ctx.hasData)
        ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
            _createVNode(_component_a_radio_group, {
              value: _ctx.currentPeriod,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentPeriod) = $event)),
              "button-style": "solid",
              onChange: _ctx.handlePeriodChange
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.periodOptions, (period) => {
                  return (_openBlock(), _createBlock(_component_a_radio_button, {
                    value: period.value,
                    key: period.value
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(period.label), 1)
                    ]),
                    _: 2
                  }, 1032, ["value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["value", "onChange"]),
            _createVNode(_component_Charts, {
              id: "pe-ttm-chart2",
              option: _ctx.chartOption
            }, null, 8, ["option"]),
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("div", _hoisted_6, "均值 " + _toDisplayString(_ctx.formatValue(_ctx.chartData.average)), 1)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("div", _hoisted_9, "均值±1倍标准差 " + _toDisplayString(_ctx.formatRange(_ctx.chartData.top, _ctx.chartData.bottom)), 1)
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("section", _hoisted_10, [
            _createVNode(_component_Nodata, {
              nodatadesc: _ctx.itemdata.title
            }, null, 8, ["nodatadesc"])
          ]))
    ]),
    _: 1
  }, 8, ["spinning"]))
}